import { useQuery, useQueryClient } from '@tanstack/react-query';
import { getAuthToken } from '../api/entryManager';

export const useGetContestSummary = (SlateId: string, Sport: string, disabled: boolean, sortBy: string) => {
    return useQuery({
        queryKey: ['contestSummary', {sortBy}],
        queryFn: async () => {
            const token = getAuthToken();
            if (!token) throw new Error('User not logged in');

            const params = {
                Token: token,
                SlateId,
                Sport,
                sortBy,
                sortOrder: 'desc',
            }

            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/userEntries/summary?` + new URLSearchParams(params));
            if (!res.ok) {
                const errorMessage = await res.json();
                throw new Error(typeof errorMessage === 'string' ? errorMessage : 'Failed to get contest summary');
            }
            const data = await res.json();

            return data;
        },
        refetchOnWindowFocus: false,
        enabled: !disabled
    })
}

export const useGetCSVTemplate = (sport: string, slateId: string, enabled: boolean) => {
    const queryClient = useQueryClient();

    return useQuery({
        queryKey: ['csvTemplate'],
        queryFn: async () => {
            const token = getAuthToken();
            if (!token) throw new Error('User not logged in');

            const params = {
                Token: token,
                Sport: sport,
                SlateId: slateId,
            }

            const res = await fetch(`${process.env.REACT_APP_API_URL}/api/userEntries/download?` + new URLSearchParams(params));
            if (!res.ok) {
                const errorMessage = await res.json();
                throw new Error(typeof errorMessage === 'string' ? errorMessage : 'Failed to download');
            }
            const data = await res.json();
            const dataString = data?.join('\n') || '';
            return dataString;
        },
        onSuccess(data) {
            queryClient.setQueryData(['csvTemplate'], () => data);
        },
        refetchOnWindowFocus: false,
        enabled: enabled
    })
}